import axios from '../index';

export const requestPatientReports = () => axios.post('/export/patient-reports');

export const requestPatientReportPdf = ({ patientId, observationId }) =>
  axios.post('/export/email-report-pdf/patientReport', { patientId, observationId });

export const requestProviderReportPdf = ({ patientId, observationId }) =>
  axios.post('/export/email-report-pdf/providerReport', { patientId, observationId });

export const requestCardiovascularReports = ({ patientId }) =>
  axios.post(`/export/cardiovascular-reports`, { patientId });

export const requestDeviceReports = ({ patientId }) =>
  axios.post(`/export/device-reports`, { patientId });
